import ItemFilter from './ItemFilter';

type DeliveryRiskType =
  | 'iteration_churn'
  | 'status_churn'
  | 'no_detailed_estimate'
  | 'risk_factors_count';

class DeliveryRiskFilter extends ItemFilter<DeliveryRiskType> {
  constructor(
    initialItems: DeliveryRiskType[],
    initialOptions: Array<[string, DeliveryRiskType]> = [
      ['Iteration churn', 'iteration_churn'],
      ['Status churn', 'status_churn'],
      ['No detailed estimates', 'no_detailed_estimate'],
      ['Flagged risk', 'risk_factors_count'],
    ],
    filterOptions: {} = {}
  ) {
    super(initialItems, initialOptions, filterOptions);
  }

  matches(record: any): boolean {
    if (!this.hasItems) return true;

    return (
      (record.riskFactorsCount && this.itemIsSelected('risk_factors_count')) ||
      (record.riskFactors?.iteration_churn &&
        this.itemIsSelected('iteration_churn')) ||
      (record.riskFactors?.status_churn &&
        this.itemIsSelected('status_churn')) ||
      (record.riskFactors?.no_detailed_estimate &&
        this.itemIsSelected('no_detailed_estimate'))
    );
  }
}

export default DeliveryRiskFilter;
